module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/899e39cd4f7b43c6c31b2e6469fafb9e.png";